import React from 'react';

// Web override for AdBanner. The native variant in AdBanner.tsx pulls in
// react-native-google-mobile-ads, which imports react-native internals
// that can't be resolved on web. Metro picks this file automatically when
// bundling for the web target.
const AdBanner: React.FC = () => null;

export default AdBanner;
